// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__Jtnqi","spin":"PrintLink_spin__2euPA"};